import React, { Component } from "react";

const MinusIcon = ({ width, fill, color }) => {
  return (
    <svg width={width} height={width} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse fill={fill} cx="9.5" cy="8.9" rx="9.5" ry="8.9" />
      <path fill={color} d="M14.5,9.9h-10c-0.6,0-1-0.4-1-0.9C3.5,8.4,4,8,4.5,8h10c0.6,0,1,0.4,1,0.9C15.5,9.5,15,9.9,14.5,9.9z" />
    </svg>

  );
};

MinusIcon.defaultProps = {
  width: 20,
  fill: "black",
  color: '#fff'
};

export default MinusIcon;
